module.exports = __webpack_public_path__ + "static/media/15.7857d90a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/15.png
// module id = 867
// module chunks = 0